<!--  -->
<template>
  <div>
    <div style="display:flex;align-items:center;margin-bottom:10px">
      <el-input
        v-model="query.remark"
        placeholder="请输入备注"
      />
      <el-input
        v-model="query.url"
        style="margin-left:10px;"
        placeholder="请输入字节小程序调起链接"
      />
      <el-button
        style="margin-left:10px;width:200px"
        type="primary"
        icon="el-icon-search"
        @click="search"
      >搜索</el-button>
      <el-button
        type="primary"
        icon="el-icon-refresh-left"
        @click="reset"
      >重置</el-button>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="id"
        label="id"
        width="80"
        align="center"
      />
      <el-table-column
        prop="url"
        label="字节小程序调起链接"
        width="400"
        align="center"
      >
        <template slot-scope="scope">
          <div class="ellipsis">{{ scope.row.url }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        align="center"
      />
      <el-table-column
        prop="remark"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            @click="chooser(scope.row)"
          >选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <PaginationRight
      :total="total"
      :page.sync="query.page"
      :limit.sync="query.page_size"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { copyv2urllist } from '@/api/massiveAdvertising/accountList.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      query: {
        page: 1,
        page_size: 10,
        remark: '',
        url: ''
      },
      tableData: [],
      total: null,
      type: null,
      loading: false
    }
  },
  created() {
    this.list()
  },
  mounted() {},
  methods: {
    list() {
      this.loading = true
      copyv2urllist(this.query).then(res => {
        console.log('res', res)
        this.tableData = res.data.list
        this.total = res.data.total
        this.loading = false
      })
    },
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    send(type) {
      this.type = type
    },
    chooser(item) {
      this.$emit('callback', item, this.type)
    },
    search() {
      this.query.page = 1
      this.list()
    },
    reset() {
      this.query.page = 1
      this.query.remark = ''
      this.query.url = ''
      this.list()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.ellipsis {
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 添加省略号 */
}
</style>
